import { createContext } from 'react'

import { ComputeEngineComparisonReportDataValues1 } from '@clinic/client'

export interface OrgAndClusterType {
  isLoading: boolean
  orgId?: string
  orgName?: string
  orgType?: OrgType
  clusterId?: string
  clusterName?: string
}

export type OrgType = 'op' | 'cloud'

export const TimeRangeContext =
  createContext<ComputeEngineComparisonReportDataValues1>(null as any)

export const OrgAndClusterContext = createContext<OrgAndClusterType>(
  null as any
)
